const apiUrl = import.meta.env.VITE_API_URL as string | undefined;
const appUrl = (import.meta.env.VITE_APP_URL as string | undefined)?.replace(/\/$/, "") ?? "";

export const PRODUCT_CONFIG = {
  name: "Narrata",
  shortName: "Narrata",
  siteUrl: import.meta.env.VITE_PUBLIC_SITE_URL || apiUrl || "https://REPLACE_WITH_PRODUCTION_DOMAIN",
  loginPath: `${appUrl}/auth`,
  appPath: `${appUrl}/app`,
  alphaLaunchDate: "2026-07-16",
} as const;

export const PUBLIC_PATHS = [
  "/",
  "/about",
  "/roadmap",
  "/news",
  "/news/closed-alpha-launch",
  "/terms",
] as const;

export type PublicPath = (typeof PUBLIC_PATHS)[number];
